<template>
    <div class="est-request-container" :class="theme">
        <div class="banner">
            <h2 class="title" v-if="cmpTitle" v-html="cmpTitle"></h2>
        </div>
        <div class="box">
            <template v-if="showMedianBox">
                <div class="median-box">
                    <p class="median-desc">{{ medianPriceDesc }}</p>
                    <p class="median-price">
                        {{ currencyFormat(medianPrice, true, 0, currencySymbol) }}
                    </p>
                </div>
            </template>
            <p class="address-tip">
                {{ $t('md-sold-detail.wantToKnowWhatYour') }}
            </p>
            <address-input
                v-model:searchText="address"
                :class="{ error: showError }"
            ></address-input>
            <div v-show="showError" class="empty-error">
                <span class="iconfont icon-error"></span>
                <span class="error-text">{{
                    $t('md-sold-detail.pleaseEnterAddress')
                }}</span>
            </div>
            <button type="button" class="address-button" @click="request">
                {{ submitText || cmpRequestButtonText }}
            </button>
            <template v-if="mlsShowAgent">
                <agent-info v-if="agentInfo" v-bind="agentInfo" />
                <template v-for="(colAgent, index) in coAgentInfo" :key="index">
                    <agent-info v-bind="colAgent" />
                </template>
            </template>
            <p class="bottom-tip">
                {{ $t('md-sold-detail.ourTeamIsReadyTo') }}
            </p>
        </div>
    </div>
</template>

<script>
import AgentInfo from './agentInfo.vue';
import util from '@/common/util';
import { mapState as rootMapState } from 'pinia';
import { usePageStore, useUserStore } from "@/store";
import { mapState } from '@/store/helpers';
import { currencyFormat } from '@/common/format';
import AddressInput from '@/components/address-input/standard.vue';
import API from '../api';
export default {
    i18next: {
        ns: 'md-sold-detail'
    },
    components: {
        AgentInfo,
        AddressInput
    },
    props: ['theme', 'submitText'],
    data: function() {
        return {
            medianPrice: 0,
            address: '',
            type: 'subdivision',
            showError: false,
            showMedianBox: false
        };
    },
    beforeMount() {
        this.getMedianPrice();
    },
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page || {},
            currencySymbol: store => store.currency?.symbol,
            company: store => store.companyInfo || {},
        }),
        ...rootMapState(useUserStore, {
            user: store => store.user,
        }),
        ...mapState({
            info: store => store.listingDetail.info || {},
            _agentInfo: store => store.listingDetail.agentInfo,
            _coAgent: store => store.listingDetail.coAgentInfo,
            _additionalAgentInfos: store => store.listingDetail.additionalAgentInfos,
            showCoAgent: store => store.showCoAgent,
        }),
        agentInfo({ _agentInfo: agent, company }) {
            if (company && company.name && agent) {
                agent.company = company.name;
            }
            return agent;
        },
        coAgentInfo({ _coAgent, _additionalAgentInfos, company }) {
            if (!this.showCoAgent) {
                return [];
            }
            let coAgentArr = [];
            if (_coAgent) {
                coAgentArr.push(_coAgent);
            }
            if (_additionalAgentInfos?.length > 0) {
                coAgentArr.push(..._additionalAgentInfos);
            }
            if (coAgentArr.length === 0) {
                return [];
            }
            return coAgentArr.map(item => {
                return {
                    ...item,
                    company: company?.name
                };
            });
        },
        cmpTitle() {
            return this.$t('md-sold-detail.whatIsYourHomeWorth');
        },
        cmpRequestButtonText() {
            return this.$t('md-sold-detail.requestAFreeAnalysis')
        },
        mlsShowAgent({ page }) {
            // 1  is displayed ， 0  hide
            let mlsOrgs = page?.mlsOrgs || [];
            let mlsOrg = mlsOrgs[0] || {};
            return mlsOrg.showAgentBlock === 1;
        },
        medianPriceDesc() {
            let { subDivisionName, zipCode } = this.info;
            if (subDivisionName) {
                return this.$t('md-sold-detail.theMedianPriceFor', {
                    name: subDivisionName
                });
            } else if (zipCode) {
                return this.$t('md-sold-detail.theMedianPriceFor', {
                    name: zipCode
                });
            }
            return '';
        }
    },
    methods: {
        getMedianPrice() {
            //  have subdivision field takes precedence subdivision
            let { subDivisionName, zipCode } = this.info;
            let params = {
                'sold-date': 180,
                key: '',
                keywordType: '',
                listingStatus: 'Sold',
                includeStat: true
            };
            if (subDivisionName) {
                params.keywordType = 'subdivision';
                params.key = subDivisionName;
                this.type = 'subdivision';
            } else if (zipCode) {
                params.keywordType = 'zipCode';
                params.key = zipCode;
                this.type = 'zipCode';
            } else {
                params = null;
                console.log(
                    'Exception: current page is sold-house,but has not subdivision or zipCode.'
                );
            }
            if (!params) {
                return; 
            }
            API.getMedianPrice.call(this, params).then(({ statsResults }) => {
                let statResultList = statsResults?.statResultList;
                if (statResultList && Array.isArray(statResultList)) {
                    let res = statResultList.find(
                        item => item.key === 'soldPrice'
                    );
                    if (res) {
                        this.medianPrice = res.median;
                        if (Number(this.medianPrice)) {
                            this.showMedianBox = true;
                        }
                    }
                }
            });
        },
        request() {
            if (!this.address) {
                this.showErrorTip();
                return;
            }
            window.location.href = `${this.pageLocation.origin}/evaluation?address=${this.address}`;
        },
        showErrorTip() {
            this.showError = true;
            util.timeout({
                handler: () => {
                    this.showError = false;
                },
                delay: 3000,
                unique: true
            });
        },
        currencyFormat: currencyFormat
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.est-request-container {
    p {
        line-height: 1;
    }
    .box {
        //  cover address-input component style
        .address-input {
            margin-top: 8px;
            height: auto;
            display: block;
            box-shadow: none;
            width: auto;
            .left-box {
                input {
                    width: 100%;
                    padding: 12px 40px 12px 10px;
                    height: 40px;
                    font-size: 14px;
                }
                .close-box.show {
                    display: block;
                }
                .icon-search {
                    display: none;
                }
            }
            .right-box {
                display: none;
            }
        }
        .empty-error {
            margin-top: 10px;
            margin-left: 5px;
            .icon-error {
                &::before {
                    color: #ff3737;
                    font-size: 12px;
                }
            }
            .error-text {
                font-size: 14px;
                color: rgba(231, 0, 0, 0.6);
            }
        }
        .address-button {
            @include ellipsis();
            @include color-button();
        }
        .median-price {
            text-align: center;
            color: var(--color-theme);
            font-family: var(--font-bold);
        }
        .address-tip {
            font-size: 12px;
        }
        .agent-info {
            .info .agent-name {
                margin-bottom: 6px;
            }
        }
    }
    &.classic {
        border-radius: 2px;
        border: solid 1px #eaeaea;
        background-color: #fafafd;
        position: relative;
        padding: 20px 15px;
        &:before {
            content: '';
            width: 100%;
            height: 4px;
            background-color: var(--color-theme);
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            position: absolute;
            top: 0;
            left: 0;
        }
        .banner {
            font-size: 22px;
            font-family: var(--font-bold);
            .title {
                color: #313b42;
                text-align: center;
            }
        }
        .box {
            margin-top: 30px;
            .median-desc {
                font-size: 14px;
                color: #313b42;
                text-align: center;
            }
            .median-price {
                margin-top: 10px;
                font-size: 36px;
            }
            .address-tip {
                margin-top: 30px;
                color: #797e8b;
            }
            /** address-input components style start */
            .address-input {
                .left-box {
                    input {
                        color: #202437;
                        border: solid 1px #d5d5d5;
                        background-color: #ffffff;
                    }
                }
                &.error {
                    .left-box input {
                        border: solid 1px #ff3737;
                    }
                }
            }
            /** address-input components style end */
            .address-button {
                padding: 10px;
                width: 100%;
                margin-top: 25px;
                border-radius: 2px;
                font-size: 16px;
                font-family: var(--font-bold);
                line-height: 1.25;
                text-align: center;
            }
            .agent-info {
                margin-top: 25px;
                &:nth-of-type(1) {
                    margin-top: 35px;
                }
            }
            .bottom-tip {
                margin-top: 8px;
                color: #797e8b;
                line-height: 1.5;
                font-size: 12px;
            }
        }
        @media (max-width: 600px) {
            &::before {
                display: none;
            }
        }
    }
    &.standard {
        position: relative;
        padding: 20px;
        border-radius: 2px;
        box-shadow: 0 5px 10px 0 rgba(170, 186, 218, 0.25);
        background-color: #ffffff;
        &:before {
            content: '';
            width: 100%;
            height: 4px;
            background-color: var(--color-theme, #03c9ff);
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            position: absolute;
            top: 0;
            left: 0;
        }
        .banner {
            font-size: 18px;
            font-family: var(--font-bold);
            .title {
                color: #515666;
            }
        }
        .box {
            margin-top: 20px;
            .median-box {
                background-color: #f8f9fd;
                padding: 20px 0;
            }
            .median-desc {
                font-size: 14px;
                color: #515666;
                text-align: center;
                font-family: var(--font-bold);
                line-height: 1.43;
            }
            .median-price {
                margin-top: 8px;
                font-size: 28px;
            }
            .address-tip {
                margin-top: 22px;
                color: #797e8b;
            }
            /** address-input components style start */
            .address-input {
                .left-box {
                    input {
                        color: #c6c8d1;
                        border: solid 1px #ebecf1;
                        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);
                        background-color: #ffffff;
                    }
                }
                &.error {
                    .left-box input {
                        border: solid 1px #ff3737;
                    }
                }
            }
            /** address-input components style end */
            .address-button {
                padding: 10px;
                width: 100%;
                margin-top: 25px;
                border-radius: 2px;
                font-size: 16px;
                font-family: var(--font-bold);
                line-height: 1.25;
                text-align: center;
            }
            .agent-info {
                margin-top: 30px;
                &:nth-of-type(1) {
                    margin-top: 35px;
                }
            }
            .bottom-tip {
                margin-top: 16px;
                color: #797e8b;
                font-size: 12px;
            }
        }
        @media (max-width: 600px) {
            &::before {
                display: none;
            }
        }
    }
    &.fashion {
        border-radius: 2px;
        color: #fff;
        .banner {
            height: 60px;
            line-height: 26px;
            font-size: 20px;
            font-family: var(--font-bold);
            background-image: linear-gradient(
                    rgba(8, 17, 38, 0.5),
                    rgba(8, 17, 38, 0.5)
                ),
                url(//static.chimeroi.com/upload/1440.jpg);
            background-size: cover;
            display: flex;
            align-items: center;
            .title {
                width: 100%;
                text-align: center;
                font-size: 18px;
                font-family: var(--font-bold);
                margin-left: 20px;
            }
        }
        .box {
            background: #242a3d;
            padding: 25px 20px 20px 20px;
            .median-desc {
                font-size: 14px;
                font-family: var(--font-bold);
                color: #fff;
                text-align: center;
            }
            .median-price {
                margin-top: 15px;
                font-size: 32px;
            }
            .address-tip {
                margin-top: 25px;
            }

            /** address-input components style start */
            .address-input {
                .left-box {
                    input {
                        color: #fff;
                        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);
                        background-color: #2f374f;
                        font-size: 12px;
                    }
                    ::-webkit-input-placeholder {
                        font-size: 12px;
                    }
                }
                &.error {
                    .left-box input {
                        border: solid 1px #ff3737;
                    }
                }
                .close-box .icon-search-close:before {
                    background: none;
                }
            }
            /** address-input components style end */
            .address-button {
                padding: 10px;
                width: 100%;
                margin-top: 25px;
                border-radius: 2px;
                font-size: 16px;
                font-family: var(--font-bold);
                line-height: 1.25;
                text-align: center;
            }
            .agent-info {
                margin-top: 35px;
                &:nth-of-type(1) {
                    margin-top: 35px;
                }
            }
            .bottom-tip {
                margin-top: 16px;
                color: #bfc9e4;
                line-height: 1.5;
                font-size: 12px;
            }
        }
    }
    &.broker {
        border-radius: 5px;
        background-color: #f7f7f7;
        position: relative;
        padding: 25px 20px 15px;
        overflow: hidden;
        &:before {
            content: '';
            width: 100%;
            height: 4px;
            background-color: var(--color-theme, #ff781d);
            position: absolute;
            top: 0;
            left: 0;
        }
        .banner {
            font-family: var(--font-bold);
            .title {
                font-size: 16px;
                color: var(--color-title);
                text-align: center;
            }
        }
        .box {
            .median-box {
                padding: 20px 0;
            }
            .median-desc {
                font-size: 12px;
                color: #505050;
                text-align: center;
            }
            .median-price {
                margin-top: 15px;
                font-size: 24px;
            }
            .address-tip {
                color: #505050;
            }
            /** address-input components style start */
            .address-input {
                .left-box {
                    input {
                        background-color: #ffffff;
                    }
                    input::placeholder {
                        color: #c6c8d1;
                    }
                }
                &.error {
                    .left-box input {
                        border: solid 1px #ff3737;
                    }
                }
            }
            /** address-input components style end */
            .address-button {
                padding: 10px;
                width: 100%;
                margin-top: 20px;
                border-radius: 20px;
                font-size: 16px;
                font-family: var(--font-bold);
                line-height: 1.25;
                text-align: center;
            }
            .agent-info {
                margin-top: 30px;
                .info {
                    .agent-name {
                        font-size: 14px;
                        margin-bottom: 10px;
                        color: var(--color-title);
                    }
                    .company,
                    .email {
                        color: var(--color-label);
                    }
                }
            }
            .bottom-tip {
                margin-top: 15px;
                color: #a8a8a8;
                font-size: 12px;
            }
        }
        @media (max-width: 600px) {
            &::before {
                display: none;
            }
        }
    }
}
</style>
